import StatIcon, { getStatDetails } from "./StatIcon";

export default StatIcon;
export { getStatDetails };
